'use client';

import { IconSidebar } from '@/components/icon-sidebar';
import { NavSidebarContent } from '@/components/nav-sidebar';
import { TopBar } from '@/components/top-bar';
import { SidebarProvider } from '@/components/ui/sidebar';
import { SpaceProvider, SpaceInfo, MembershipInfo } from '@/contexts/space-context';
import { ProjectProvider } from '@/contexts/project-context';
import { MeetingProvider } from '@/contexts/meeting-context';
import { MeetingBar } from '@/components/meetings/meeting-bar';
import { usePathname } from '@/compat/navigation';
import { PageWithSidebar } from '@/components/layouts/page-with-sidebar';

interface SpaceLayoutClientProps {
  children: React.ReactNode;
  space: SpaceInfo;
  membership: MembershipInfo;
}

export function SpaceLayoutClient({ children, space, membership }: SpaceLayoutClientProps) {
  const pathname = usePathname();

  const showNavSidebar = !pathname.includes('/wiki') &&
    !pathname.includes('/mail') &&
    !pathname.includes('/feed') &&
    !pathname.includes('/chat') &&
    !pathname.includes('/meetings') &&
    !pathname.includes('/settings');

  return (
    <SpaceProvider space={space} membership={membership}>
      <ProjectProvider spaceSlug={space.slug}>
        <MeetingProvider>
          <SidebarProvider defaultOpen={true}>
            <div className="flex flex-col h-screen w-full overflow-hidden bg-muted pt-2">
              <div className="px-2">
                <TopBar />
              </div>

              <div className="flex flex-1 overflow-hidden">
                <div className="hidden md:block">
                  <IconSidebar />
                </div>

                <div className="flex flex-1 mt-1 md:mt-2 ml-1 md:ml-0 mr-1 md:mr-2 mb-2 rounded-xl bg-background border shadow-sm overflow-hidden">
                  {showNavSidebar ? (
                    <PageWithSidebar
                      sidebar={<NavSidebarContent />}
                      sidebarTitle="Navigation"
                    >
                      {children}
                    </PageWithSidebar>
                  ) : (
                    <div className="flex flex-1 flex-col overflow-hidden">
                      {children}
                    </div>
                  )}
                </div>
              </div>

              <MeetingBar />
            </div>
          </SidebarProvider>
        </MeetingProvider>
      </ProjectProvider>
    </SpaceProvider>
  );
}

